import { useRouter } from 'next/router'
import Link from 'next/link'
import Header from "../src/local/Header"
import styles from '../styles/Menu.module.css'

function SetLink({ href, title }: { href: string; title: string }) {
	const router = useRouter()
	const current = router.query.referer === (href === "/" ? undefined : href)
	return (
		<Link href={href} style={{ color: current ? "#FF8400" : "#FFD6AA" }}>{title}</Link>
	)
}

export default function Menu() {
	return (
		<div className={styles.main}>
			<Header />
			<ol>
				<li>
					<SetLink href="/" title="Kezdőoldal" />
				</li>
				<li>
					<SetLink href="/Bemutato" title="Bemutató" />
				</li>
				<li>
					<SetLink href="/Elerhetoseg" title="Elérhetőség" />
				</li>
				<li>
					<SetLink href="/Telepulesek" title="Települések" />
				</li>
				<li>
					<SetLink href="/Onkormanyzat" title="Önkormányzat" />
				</li>
			</ol>
		</div>
	)
}